import Vue from 'vue'
import Show from './Show'
import ServiceState from './ServiceState'

Vue.component('ServeShow', Show)
Vue.component('ServiceState', ServiceState)
